import React from "react";

import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RefreshIcon from "@mui/icons-material/Refresh";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { Button, IconButton, Stack } from "@mui/material";
import { StyledStack } from "components/My-deals/Dashboard/StyledStack";
import { Menu } from "components/popups";
import { Search } from "components/Search/Search";
import { useModals, useNavigate } from "hooks";
import { useDataRoomsActions } from "store";

interface Props {
  isShowAllFilesEnabled: boolean;
  refetchRooms: () => void;
  connectAll: () => Promise<void>;
  importInvestors: ({ matchWithDeals, toastMsg }: { matchWithDeals: boolean; toastMsg: string }) => Promise<void>;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const iconBtnsStyles = {
  color: "#0a3142",
  background: "white",
  border: "0.5px solid #bac7ce"
};

export const RoomsManageBar: React.FC<Props> = ({
  isShowAllFilesEnabled,
  refetchRooms,
  connectAll,
  importInvestors,
  searchTerm,
  onSearchChange
}) => {
  const navigate = useNavigate();
  const { openDataroomConnect } = useModals();
  const { downloadStatusCsv } = useDataRoomsActions();

  return (
    <StyledStack sx={{ flexDirection: "row", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
      <Stack>
        <Search placeholder="Search..." value={searchTerm} onChange={(e) => onSearchChange(e.target.value)} />
      </Stack>
      <Stack direction="row" sx={{ gap: "10px" }}>
        <Button
          onClick={() => {
            // hasEffectRun.current = false;
            navigate({ route: "dataRoomsAllFiles" });
          }}
          sx={iconBtnsStyles}
          size="sm"
          startIcon={<ExitToAppIcon fontSize="md" />}
          disabled={isShowAllFilesEnabled}
        >
          Show All Files
        </Button>
        <Button onClick={connectAll} sx={iconBtnsStyles} size="sm">
          <RefreshIcon fontSize="md" />
          Connect to All Portals
        </Button>
        <Button
          onClick={() => openDataroomConnect()}
          variant="contained"
          size="sm"
          startIcon={<AddIcon fontSize="md" />}
        >
          Add Portal
        </Button>
        <IconButton
          onClick={() => {
            refetchRooms();
            // hasEffectRun.current = false;
          }}
          sx={iconBtnsStyles}
          size="sm"
          title="Reload"
        >
          <RefreshIcon fontSize="md" />
        </IconButton>
        <Menu
          iconButtonProps={{ sx: iconBtnsStyles, size: "sm" }}
          icon={<MoreVertIcon fontSize="md" />}
          options={[
            {
              title: "Import investors",
              // disabled: isOnProcess,
              icon: <UploadFileOutlinedIcon sx={{ fontSize: "20px" }} />,
              onClick: () => importInvestors({ matchWithDeals: false, toastMsg: "All investors imported" })
            },
            {
              title: "Import investors and match",
              icon: <UploadFileOutlinedIcon sx={{ fontSize: "20px" }} />,
              onClick: () => importInvestors({ matchWithDeals: true, toastMsg: "All investors imported and matched" })
            },
            {
              title: "Download Datarooms Status (CSV)",
              icon: <DownloadIcon sx={{ fontSize: "20px" }} />,
              onClick: downloadStatusCsv
            }
          ]}
        />
      </Stack>
    </StyledStack>
  );
};
